import { render, staticRenderFns } from "./InvoiceArrivedView.vue?vue&type=template&id=5450395b&scoped=true&"
import script from "./InvoiceArrivedView.vue?vue&type=script&lang=js&"
export * from "./InvoiceArrivedView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceArrivedView.vue?vue&type=style&index=0&id=5450395b&lang=scss&scoped=true&"
import style1 from "./InvoiceArrivedView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5450395b",
  null
  
)

export default component.exports